import { render, staticRenderFns } from "./ResidentialProxies.vue?vue&type=template&id=7a5b96a3&scoped=true"
import script from "./ResidentialProxies.vue?vue&type=script&lang=js"
export * from "./ResidentialProxies.vue?vue&type=script&lang=js"
import style0 from "./ResidentialProxies.vue?vue&type=style&index=0&id=7a5b96a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5b96a3",
  null
  
)

export default component.exports